// Web startup: read Vite env, inject it into the shared layer, and initialize
// Firebase. Imported first in main.tsx so it runs before any service is called.
import { configureAppEnv } from '@shared/config/env';
import { initFirebase } from '@shared/services/firebase';

configureAppEnv({
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  },
  claudeProxyUrl: import.meta.env.VITE_CLAUDE_API_PROXY_URL,
  claudeApiKey: import.meta.env.VITE_CLAUDE_API_KEY,
  useEmulators: import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === 'true',
});

// Web uses Firebase's default (browser) auth persistence — no factory needed.
initFirebase();
